/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import _TdTree from './td-tree.js';
import mapProps from '../utils/map-props.js';
import { withInstall } from '../utils/withInstall.js';
import './style/css.js';
import './interface.js';
import 'lodash/upperFirst';
import 'lodash/pick';
import '../utils/mixins.js';
import 'vue';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../_common/js/tree/tree-store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '@babel/runtime/helpers/defineProperty';
import 'lodash/difference';
import 'lodash/camelCase';
import 'lodash/isPlainObject';
import '../_common/js/tree/tree-node.js';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/regenerator';
import 'lodash/uniqueId';
import 'lodash/isNil';
import 'lodash/get';
import '../_common/js/tree/tree-node-model.js';
import 'lodash/omit';
import '../_common/js/log/log.js';
import './tree-item.js';
import 'lodash/isFunction';
import 'tdesign-icons-vue';
import '../checkbox/index.js';
import '../checkbox/group.js';
import '../_chunks/dep-9d6f3de6.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/intersection';
import '../checkbox/checkbox.js';
import '../utils/render-tnode.js';
import 'lodash/kebabCase';
import '../checkbox/props.js';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../utils/event.js';
import '../checkbox/checkbox-group-props.js';
import '../checkbox/type.js';
import 'lodash/capitalize';
import '../loading/index.js';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../loading/type.js';
import '../loading/plugin.js';
import '../config.js';
import './util.js';
import '../utils/ripple.js';
import './props.js';
import './type.js';

var Tree = withInstall(mapProps([{
  name: "value",
  event: ["change", "update:value"]
}, {
  name: "expanded",
  event: ["expand", "update:expanded"]
}, {
  name: "actived",
  event: ["active", "update:actived"]
}], {
  model: {
    prop: "value",
    event: "change"
  }
})(_TdTree));

export { Tree, Tree as default };
//# sourceMappingURL=index.js.map
